import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { APP_SETTINGS } from '../../shared/models/backofficeConfiguration';
import { ExecuteService } from '../../shared/services/executeService.service';
import { ErrorHandlerService } from '../../shared/services/errorHandler.service';
import { Observable } from 'rxjs';

@Injectable()
export class UserSettingsService {
  private basicUserSettingsApiURL = APP_SETTINGS.BasicUserSettingsApiUrl;
  private calendarSettingsApiURL = APP_SETTINGS.CalendarSettingsApiUrl;
  private ratesTableSettingsApiURL = APP_SETTINGS.RatesTableSettingsApiUrl;

  constructor(
    private executeService: ExecuteService,
    private errorHandler: ErrorHandlerService) {
  }

  public Delete(email: string): Observable<any> {
    return Observable.forkJoin([
      this.DeleteSettings(this.basicUserSettingsApiURL, 'BasicUserSettings', email),
      this.DeleteSettings(this.calendarSettingsApiURL, 'CalendarSettings', email),
      this.DeleteSettings(this.ratesTableSettingsApiURL, 'RatesTableSettings', email)
    ]);
  }

  private DeleteSettings(apiUrl: string, apiName: string, email: string): Observable<any> {
    const url = apiUrl + email;
    return this.executeService.ExecuteWithToken('delete', url)
      .pipe(
        catchError(this.errorHandler.handleAndThrowError('UserSettingsService_Delete ' + apiName, null, true))
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/users/services/userSettings.service.ts